<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {onMounted, ref, computed} from "vue";
//axios请求
import {inject} from 'vue'
import {ArrowRight} from '@element-plus/icons-vue'

onMounted(() => {
  get_corr()
  showRnaseq();
});
const $axios = inject('$axios')
const rna_seqList = ref([])
const corrlist = ref([])
const inputText = ref('')
const module = ref('1')
const rna_seqList2 = ref([])
//分页器

// 默认显示第几页
const currentPage = ref(1)
// 个数选择器（可修改）
let pageSizes = [20, 50, 100, 200, 300, 400]
// 默认每页显示的条数（可修改）
const PageSize = ref(20)

// 显示第几页
function handleCurrentChange(val) {
  // 改变默认的页数
  currentPage.value = val
}

function handleSizeChange(val) {
  // 改变每页显示的条数
  PageSize.value = val
  // 注意：在改变每页显示的条数时，要将页码显示到第一页
  currentPage.value = 1
}

function inputInput(e) {
  inputText.value = e.target.value;
  showRnaseq();
}

const gene1Text = ref('CODG10130')
const gene2Text = ref('CODG10126')

function gene1Input(e) {
  gene1Text.value = e.target.value;
}

function gene2Input(e) {
  gene2Text.value = e.target.value;
}


function showRnaseq() {
  loadtable1.value = true
  $axios.get('http://bioinfo-sysu.com:8282/api/co_expression_search?input=' + inputText.value + '&module=' + module.value).then((resp) => {
    if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
      rna_seqList.value = JSON.parse(JSON.stringify(resp.data))['list']
    }
    loadtable1.value = false
  }).catch((err) => {
    loadtable1.value = false
    console.log(err)
  })
}

function get_corr() {
  loadtable.value = true
  $axios.get('http://bioinfo-sysu.com:8282/api/get_corr?gene1=' + gene1Text.value + '&gene2=' + gene2Text.value).then((resp) => {
    corrlist.value = resp.data
    loadtable.value = false
  }).catch((err) => {
    console.log(err)
    loadtable.value = false
  })
}


const sortCorNum = ref(1)

function sortCor() {
  if (sortCorNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].correlation)
      var nameB = parseFloat(b['fields'].correlation)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortCorNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].correlation)
      var nameB = parseFloat(b['fields'].correlation)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortCorNum.value = 1
  }
}

const sortPNum = ref(1)

function sortP() {
  if (sortPNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].pvalue)
      var nameB = parseFloat(b['fields'].pvalue)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortPNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].pvalue)
      var nameB = parseFloat(b['fields'].pvalue)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortPNum.value = 1
  }
}

const sortAPNum = ref(1)

function sortAP() {
  if (sortAPNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].adjpvalue)
      var nameB = parseFloat(b['fields'].adjpvalue)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortAPNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].adjpvalue)
      var nameB = parseFloat(b['fields'].adjpvalue)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortAPNum.value = 1
  }
}
const loadtable = ref(false)
const loadtable1 = ref(false)

// const downloadFile = (fileName) => {
//   // 文件路径（假设文件名为data.csv）
//   const filePath = './file/' +fileName// 文件位于public目录下
//
//   // 创建隐藏的可下载链接
//   const link = document.createElement('a')
//   link.href = filePath
//   link.download = fileName // 设置下载文件名
//
//   // 添加到DOM并触发点击
//   document.body.appendChild(link)
//   link.click()
//
//   // 清理DOM
//   document.body.removeChild(link)
// };
</script>
<template>
  <div>
    <index-navbar/>
    <section class="relative w-full h-full py-40 min-h-screen">
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="col-12 my-3">
          <el-breadcrumb :separator-icon="ArrowRight" style="font-size: 22px">
            <el-breadcrumb-item :to="{ path: '/' }"><i class="bi bi-house me-1"></i>Home</el-breadcrumb-item>
            <el-breadcrumb-item>Co-Expression</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="col-12">
          <div class="border-t border-blueGray-200 text-center">
            <div class="flex flex-wrap justify-center">
              <div class="w-full lg:w-9/12 px-4">
                <p class="text-lg leading-relaxed text-blueGray-700">
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="col-md-6">-->
        <!--          <img :src="UMAP_celltype">-->
        <!--        </div>-->
        <!--        <div class="col-md-6">-->
        <!--          <img :src="edit_FeaturePlot">-->
        <!--        </div>-->
        <div class="col-12 my-6 ">
          <span class="font-bold">Bulk RNA-seq Pearson correlation（Log1p TPM）：</span>
          <div class="text-center mt-12 d-flex flex-column">
            <div class="d-flex flex-row justify-content-center align-items-center">
              <span>Gene A:</span>
              <input type="text" placeholder="chr14:106539192:CT" @input="gene1Input" :value="gene1Text"
                     class="mx-3 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>
              <span>Gene B:</span>
              <input type="text" placeholder="chr14:106539192:CT" @input="gene2Input" :value="gene2Text"
                     class="mx-3 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>

              <button
                  class="mx-3 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  @click="get_corr">
                Submit
              </button>
            </div>
          </div>
          <table class="table table-striped table-bordered table-md align-middle mt-4"
                 style="text-align: left;table-layout:fixed" v-loading="loadtable">
            <thead>
            <tr>
              <th scope="col" style="width: 20%">Gene A</th>
              <th scope="col" style="width: 20%">Gene B</th>
              <th scope="col" style="width: 20%">Pearson's r</th>
              <th scope="col" style="width: 20%">P value</th>
              <th scope="col" style="width: 20%">n_samples</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                <router-link
                    :to="{name:'genedetail',query:{gene:corrlist.gene1}}">
                  <el-link>{{ corrlist.gene1 }}</el-link>
                </router-link>
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                <router-link
                    :to="{name:'genedetail',query:{gene:corrlist.gene2}}">
                  <el-link>{{ corrlist.gene2 }}</el-link>
                </router-link>
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ corrlist.pearson_r }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ corrlist.p_value }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ corrlist.n_samples }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12">
          <div class="d-flex flex-row justify-content-start align-items-center">
            <!--            <button-->
            <!--                class="bg-black text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"-->
            <!--                type="button"-->
            <!--                @click="downloadFile('GSE157007_edit_data.csv')">-->
            <!--              download-->
            <!--            </button>-->
            <span class="font-bold">Select a module:</span>
            <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example" v-model="module"
                    style="width: 20%; color: #ccc;" @change="showRnaseq">
              <option value="" disabled selected hidden>Module</option>
              <option value="1" style="color: black;">1</option>
              <option value="2" style="color: black;">2</option>
              <option value="3" style="color: black;">3</option>
              <option value="4" style="color: black;">4</option>
              <option value="5" style="color: black;">5</option>
              <option value="6" style="color: black;">6</option>
              <option value="7" style="color: black;">7</option>
              <option value="8" style="color: black;">8</option>
              <option value="9" style="color: black;">9</option>
              <option value="10" style="color: black;">10</option>
              <option value="11" style="color: black;">11</option>
              <option value="12" style="color: black;">12</option>
              <option value="13" style="color: black;">13</option>
              <option value="14" style="color: black;">14</option>
              <option value="15" style="color: black;">15</option>
              <option value="16" style="color: black;">16</option>
              <option value="17" style="color: black;">17</option>
              <option value="18" style="color: black;">18</option>
              <option value="19" style="color: black;">19</option>
              <option value="20" style="color: black;">20</option>
              <option value="21" style="color: black;">21</option>
              <option value="22" style="color: black;">22</option>
              <option value="23" style="color: black;">23</option>
              <option value="24" style="color: black;">24</option>
              <option value="25" style="color: black;">25</option>
              <option value="26" style="color: black;">26</option>
              <option value="27" style="color: black;">27</option>
              <option value="28" style="color: black;">28</option>
            </select>
          </div>
          <table class="table table-striped table-bordered table-md align-middle mt-4"
                 style="text-align: left;table-layout:fixed" v-loading="loadtable1">
            <thead>
            <tr>
              <th scope="col" style="width: 10%">Module</th>
              <th scope="col" style="width: 15%">Gene</th>
              <th scope="col" style="width: 15%">kTotal</th>
              <th scope="col" style="width: 15%">kWithin</th>
              <th scope="col" style="width: 15%">kOut</th>
              <th scope="col" style="width: 15%">kDiff</th>
              <th scope="col" style="width: 15%">Module kME</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                <input type="text" placeholder="Search Gene ID" @input="inputInput" :value="inputText"
                       class="w-full placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">-
              </td>
            </tr>
            <tr v-for="(item,index) in rna_seqList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].module }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                <router-link
                    :to="{name:'genedetail',query:{gene:item['fields'].gene}}">
                  <el-link>{{ item['fields'].gene }}</el-link>
                </router-link>
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].ktotal }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].kwithin }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].kout }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].kdiff }}
              </td>
              <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                {{ item['fields'].module_kme }}
              </td>
            </tr>
            </tbody>
          </table>
          <!--    分页操作-->
          <el-pagination
              class="el-pager mt-3"
              style="--el-color-primary:#303034"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageSizes"
              :page-size="PageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="rna_seqList.length">
          </el-pagination>
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
